export function getCurrentDate () {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0') // 月份从0开始，补齐两位
  const day = String(now.getDate()).padStart(2, '0') // 补齐两位
  return `${year}-${month}-${day}`
}
export function formatDateToYYMMDD (currentDate) {
  // 获取年份的后两位、月份和日期
  let year = String(currentDate.getFullYear()).slice(2) // 获取年份的后两位
  let month = String(currentDate.getMonth() + 1).padStart(2, '0') // 月份从0开始，需要加1
  let day = String(currentDate.getDate()).padStart(2, '0')

  // 拼接成目标格式
  return `${year}${month}${day}`
}
export function formatCurrentDate (currentDate) {
  // 获取年份、月份、日期、小时、分钟和秒
  let year = currentDate.getFullYear()
  let month = String(currentDate.getMonth() + 1).padStart(2, '0') // 月份从 0 开始，所以要加 1
  let day = String(currentDate.getDate()).padStart(2, '0')
  let hours = String(currentDate.getHours()).padStart(2, '0')
  let minutes = String(currentDate.getMinutes()).padStart(2, '0')
  let seconds = String(currentDate.getSeconds()).padStart(2, '0')

  // 拼接成目标格式
  return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`
}
export function formatDate (date) {
  const d = new Date(date)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0') // 补齐两位
  const day = String(d.getDate()).padStart(2, '0') // 补齐两位
  return `${year}-${month}-${day}`
}

export function generateRandomString () {
  const part0 = '140350429426'
  // 生成 12 个随机数字
  const part1 = generateRandomDigits(12)

  // 生成 8 个随机数字
  const part2 = generateRandomDigits(8)

  // 生成 7 个随机字母和数字
  const part3 = generateRandomAlphanumeric(3, 5) // 或者调整生成的数字和字母数量
  // 将三部分用空格连接起来
  return `${part0}${part1} ${part2} ${part3}`
}
// 生成指定数量的随机数字
export function generateRandomDigits (length) {
  let result = ''
  const digits = '0123456789'

  for (let i = 0; i < length; i++) {
    result += digits[Math.floor(Math.random() * digits.length)]
  }

  return result
}
// 生成指定数量的随机字母和数字
export function generateRandomAlphanumeric (numDigits, numLetters) {
  let result = ''
  const digits = '0123456789'
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

  // 生成数字部分
  for (let i = 0; i < numDigits; i++) {
    result += digits[Math.floor(Math.random() * digits.length)]
  }

  // 生成字母部分
  for (let i = 0; i < numLetters; i++) {
    result += letters[Math.floor(Math.random() * letters.length)]
  }

  return result
}
export function formatStringNumber (value) {
  // 检查输入是否为数字字符串
  if (isNaN(value)) {
    return 'Invalid number'
  }
  // 转为数字后格式化
  return parseFloat(value).toFixed(3)
}



// WEBPACK FOOTER //
// ./src/utils.js